module.exports = __webpack_public_path__ + "static/media/Tourist2.9e94a1e9.jpg";